<template>
  <div>
    <router-view />
  </div>
</template>

<script>
    export default {
        name: "towLevelView"
    }
</script>

<style scoped>

</style>
